import { Divider } from "@/react/components/search/Divider";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { ExpandableListItemSkeleton } from "./ExpandableListItemSkeleton";

interface ExpandableAccordionSkeletonProps {
  className?: string;
  initialVisibleCount: number;
  title: string;
}

export const ExpandableAccordionSkeleton = ({
  className,
  title,
  initialVisibleCount,
}: ExpandableAccordionSkeletonProps) => (
  <div
    className={classNames(
      "border-primary flex flex-col rounded-xl border bg-primary",
      className,
    )}
  >
    <div className="border-primary flex items-center gap-x-2 border-b px-6 py-3">
      <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
    </div>

    <ul className="flex list-none flex-col">
      {Array.from({ length: initialVisibleCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key -- No need to use a unique key
        <div key={index}>
          <ExpandableListItemSkeleton />
          {index < initialVisibleCount - 1 && <Divider />}
        </div>
      ))}
    </ul>
  </div>
);
